export const FORUM_ORIGIN = 'https://forum.hearingtracker.com'

// Forum members get a public profile at /u/<username>. `profiles.username` is
// citext over there, so the link resolves whatever case the stored name uses —
// we pass it through verbatim rather than normalizing it here.
export const forumProfileUrl = (username: string | null | undefined): string | null => {
  const name = username?.trim()
  if (!name) {
    return null
  }
  return `${FORUM_ORIGIN}/u/${encodeURIComponent(name)}`
}
